import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { Modal } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAdmissions,
  deleteAdmission,
  updateAdmissionStatus,
} from "../../redux/actions/admin/admissionAction";
import PageTitle from "../../Components/PageTitle";
import Table from "../common/Table";
import EditAdmissionDetails from "./EditAdmissionDetails";

const Admission = () => {
  const dispatch = useDispatch();
  const { admissions } = useSelector((state) => state.admissions);
  const [search, setSearch] = useState("");
  const [filteredAdmission, setFilteredAdmission] = useState([]);

  useEffect(() => {
    dispatch(getAllAdmissions());
  }, [dispatch]);

  useEffect(() => { 
    setFilteredAdmission(admissions);
  }, [admissions]);

    // Function to refresh the admissions data
    const refreshData = () => {
      dispatch(getAllAdmissions()); // Refresh data after update
    };

  // Handle Search
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filteredData = admissions.filter(
      (item) =>
        item.studentName.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value)
    );
    setFilteredAdmission(filteredData);
  };

  // Delete Admission
  const { confirm } = Modal;
  const handleDeleteAdmission = (id) => {
    confirm({
      title: "Are you sure you want to delete this Admission?",
      content: "Once deleted, this admission cannot be recovered.",
      okText: "Yes, Delete",
      cancelText: "No, Cancel",
      onOk: async () => {
        await dispatch(deleteAdmission(id));
        dispatch(getAllAdmissions());
      },
    });
  };

  // Admission Status Update
  const handleStatusChange = (id, paymentStatus) => {
    confirm({
      title: "Are you sure?",
      content: `Do you really want to change the status to "${paymentStatus}"?`,
      okText: "Yes, Change",
      cancelText: "No, Cancel",
      onOk: async () => {
        await dispatch(updateAdmissionStatus(id, paymentStatus));
        dispatch(getAllAdmissions());
      },
    });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "Actions",
      width: 90,
      renderCell: (value) => (
        <Box>
          <IconButton
            aria-label="delete"
            onClick={() => handleDeleteAdmission(value?.row?._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
          <EditAdmissionDetails
            id={value?.row?._id}
            studentName={value?.row?.studentName}
            fatherName={value?.row?.fatherName}
            motherName={value?.row?.motherName}
            email={value?.row?.email}
            phone={value?.row?.phone}
            gender={value?.row?.gender}
            birthDate={value?.row?.birthDate}
            className={value?.row?.className}
            courseName={value?.row?.courseName}
             presentAddress={value?.row?.presentAddress}
             presentDivision={value?.row?.presentDivision}
             presentDistrict={value?.row?.presentDistrict}
             permanentAddress={value?.row?.permanentAddress}
             permanentDivision={value?.row?.permanentDivision}
             permanentDistrict={value?.row?.permanentDistrict}
             paymentDate={value?.row?.paymentDate}
             transactionId={value?.row?.transactionId}
paymentStatus={value?.row?.paymentStatus}
            refreshData={refreshData}

          />
        </Box>
      ),
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: true,
      renderCell: (params) => (
        <div style={{ width: "100%" }}>
          <select
            value={params?.row?.paymentStatus || ""}
            onChange={(e) =>
              handleStatusChange(params?.row?._id, e.target.value)
            }
            style={{
              padding: "6px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: `1px solid ${
                params?.row?.paymentStatus === "Completed"
                  ? "green"
                  : params?.row?.paymentStatus === "Failed"
                  ? "red"
                  : "#ccc"
              }`,
              backgroundColor:
                params?.row?.paymentStatus === "Completed"
                  ? "#e0ffe0"
                  : params?.row?.paymentStatus === "Failed"
                  ? "#ffe0e0"
                  : "#fff",
              color:
                params?.row?.paymentStatus === "Completed"
                  ? "green"
                  : params?.row?.paymentStatus === "Failed"
                  ? "red"
                  : "#333",
              cursor: "pointer",
              outline: "none",
              transition:
                "border-color 0.2s, background-color 0.2s, color 0.2s",
            }}
          >
            <option value="Completed">Completed</option>
            <option value="Failed">Failed</option>
            <option value="Pending">Pending</option>
          </select>
        </div>
      ),
    },

    {
      field: "transactionId",
      headerName: "Transaction ID",
      width: 150,
      editable: true,
    },

    {
      field: "studentName",
      headerName: "Student Name",
      width: 150,
      editable: true,
    },
    {
      field: "fatherName",
      headerName: "Parent Name",
      width: 150,
      editable: true,
    },
    {
      field: "email",
      headerName: "E-mail",
      width: 200,
      editable: true,
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 150,
      editable: true,
    },
    {
      field: "className",
      headerName: "Class Applied",
      width: 150,
      editable: true,
    },
     {
      field: "courseName",
      headerName: "Course Applied",
      width: 150,
      editable: true,
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 180,
      renderCell: (params) =>
        moment(params?.row?.createdAt).format("MM/DD/YYYY"),
    },
  ];

  return (
    <div>
      <PageTitle title="Admin Admissions | Test Series" />
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          mb: 3,
          fontFamily: "Poppins, sans-serif",
          color: "#2C3E50",
          letterSpacing: "2.5px",
          lineHeight: 1.8,
        }}
      >
        Admissions
      </Typography>
      
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          // mb: 2,
          mb:5,
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "primary.main" }}>Admissions</Typography>
      </Breadcrumbs>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search by Name, or Email"
        value={search}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <IconButton>
              <SearchIcon sx={{ color: "#1976d2" }} />
            </IconButton>
          ),
        }}
        sx={{
          mb: 3,
          bgcolor: "white",
          borderRadius: "20px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
      <Box
        style={{
          width: "auto",
          overflowY: "hidden",
          overflowX: "scroll",
        }}
      >
        <Box
          sx={{
            pb: 2,
            display: "flex",
            width: "auto",
            justifyContent: "right",
          }}
        ></Box>
        <Table data={filteredAdmission} columns={columns} />
      </Box>
    </div>
  );
};

export default Admission;
